






























































































































































































































import _ from "lodash";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import axios from "axios";
import database from "@/database";
import moment from "moment";
import QuickFacts from "@/documents/quick_facts.vue";
import TagSelectCountryByISO3 from "@/components/tag_select_country_by_iso3.vue";
import TagSelectPublisher from "@/components/tag_select_publisher.vue";
import FactsTable from "@/facts/table.vue";

@Component({
  components: {
    QuickFacts,
    TagSelectCountryByISO3,
    TagSelectPublisher,
    FactsTable,
  },
})
export default class DocumentForm extends Vue {
  @Prop() private id?: number;
  @Prop() private isClone?: boolean;

  private activeTab: number = 0;
  private loading: boolean = false;
  private typeOptions: string[] = [
    "Web",
    "PDF",
    "Email",
    "Excel",
    "Phone",
    "Fax",
  ];
  private loadingOptions: boolean = false;
  private grabFileLoading: boolean = false;
  private factCount: number = 0;
  private dateFieldOptions: any = {
    disabledDate(date: Date) {
      return date && date.valueOf() > Date.now();
    },
  };

  private document: any = {
    id: this.id,
    uuid: null,
    filename: null,
    content_type: null,
    original_filename: null,
    name: "",
    type: "",
    publication_date: null,
    comment: "",
    url: "",
    confidential: false,
    displacement_types: [],
    countries: [],
    sources: [],
    publishers: [],
  };

  created() {
    if (this.id == null) {
      this.getUUID();
    } else {
      this.load();
    }
  }

  get isNew() {
    return this.document.id == null || this.isClone;
  }

  get namePublishers() {
    let publishers = "";
    if (
      this.document.publishers != null &&
      this.document.publishers.length > 0
    ) {
      publishers =
        this.document.publishers.map((p: any) => p.name).join(", ") + ": ";
    }
    return publishers;
  }

  get nameCountries() {
    let countries = "";
    if (this.document.countries != null && this.document.countries.length > 0) {
      countries = " (" + this.document.countries.join(", ") + ")";
    }
    return countries;
  }

  get nameDate() {
    let publicationDate = "";
    let date = moment(this.document.publication_date);
    if (this.document.publication_date != null && date.isValid()) {
      publicationDate = " - " + date.format("DD/MM/YYYY");
    }
    return publicationDate;
  }

  get fullname() {
    return (
      this.namePublishers +
      this.document.name +
      this.nameCountries +
      this.nameDate
    );
  }

  get rules() {
    return {
      name: [
        {
          required: true,
          message: "Name is required",
        },
        {
          min: 3,
          message: "Length should be more thab 3",
        },
      ],
      publication_date: {
        required: true,
        message: "Publication date is required",
      },
      sources: {
        required: true,
        message: "Sources are required",
      },
      publishers: {
        required: true,
        message: "Sources are required",
      },
      url: [
        {
          type: "url",
          message: "URL is not valid",
        },
      ],
    };
  }

  // Load a document by ID
  async load() {
    if (this.id != null) {
      this.loading = true;
      this.$Loading.start();
      try {
        let response = await axios.get("/psql/documents", {
          params: { id: `eq.${this.id}` },
          headers: { Accept: "application/vnd.pgrst.object+json" },
        });
        response.data.publication_date = new Date(
          response.data.publication_date
        );
        // Remove all unique ids if clone
        if (this.isClone) {
          delete response.data.id;
          delete response.data.uuid;
          delete response.data.serial_no;
          delete response.data.gsn;
        }
        // Update model
        this.document = response.data;
        // UUID
        if (this.document.uuid == null) {
          this.getUUID();
        }
        // Loader off
        this.$Loading.finish();
      } catch (error) {
        console.error(error);
        this.$Loading.error();
      }
      this.loading = false;
    }
  }

  async save() {
    if (!this.$can("manage", "documents")) {
      this.$Message.error("User is not permitted");
      return;
    }

    const isNew = this.isNew;
    // @ts-ignore
    this.$refs["documentForm"].validate(async (valid: boolean) => {
      if (valid) {
        this.$Loading.start();
        try {
          let response = await database.save(
            "documents",
            _.cloneDeep(this.document),
            {}
          );
          console.log(response);
          this.document = response.data;
          this.$Notice.success({
            title: "Success",
            desc: `Document has been ${isNew ? "created" : "updated"}`,
          });
          this.$router.push(`/documents/${this.document.id}`);
        } catch (error) {
          console.error(error.response);
          this.$Notice.error({
            title: "Failed",
            desc: `Document was not ${isNew ? "created" : "updated"}`,
          });
        }
      } else {
        this.$Message.error("Check form errors");
      }
    });
  }

  // Drop a document from the database
  async drop() {
    if (!this.$can("delete", "documents")) {
      this.$Message.error("User is not permitted");
      return;
    }

    this.$Modal.confirm({
      title: "Delete Document",
      content:
        "This action will permanently delete this document, are you sure?",
      onOk: async () => {
        this.$Loading.start();
        try {
          await axios.delete("documents", this.document.id);
          this.$Notice.success({
            title: "Success",
            desc: `The document has been deleted`,
          });
          this.$router.push(`/documents`);
        } catch (error) {
          console.error(error.response);
          this.$Notice.error({
            title: "Failed",
            desc: `Failed to deleted the document`,
          });
        }
      },
    });
  }

  async grabFile() {
    this.grabFileLoading = true;

    if (!this.document.uuid) {
      let response = await this.getUUID();
    }

    try {
      let response = await axios.post("/upload/url", {
        uuid: this.document.uuid,
        url: this.document.url,
      });
      this.document.filename = response.data.filename;
      this.document.content_type = response.data.content_type;
      this.document.original_filename =
        response.data.original_filename === ""
          ? null
          : response.data.original_filename;
      this.$Notice.success({
        title: "Success",
        desc: "The file has been created successfully",
      });
    } catch (error) {
      console.error(error.response);
      this.$Notice.error({
        title: "Failed",
        desc: "The file has failed to be created",
      });
    }
    this.grabFileLoading = false;
  }

  fileUploaded(response: any) {
    this.document.original_filename = response.original_filename;
    this.document.filename = response.filename;
    this.document.content_type = response.content_type;
    this.$Notice.success({
      title: "Success",
      desc: `${response.original_filename} has been uploaded successfully`,
    });
  }

  async getUUID() {
    try {
      let response = await axios.post("/psql/rpc/uuid_generate_v4");
      this.document.uuid = response.data;
    } catch (error) {
      console.error(error);
      this.$Notice.error({
        title: "Error",
        desc: "Failed to fetch a UUID",
      });
    }
  }
}

// import _ from "lodash";
// import axios from "axios";
// import database from "@/database";
// import moment from "moment";
// import QuickFacts from "@/documents/quick_facts.vue";
// import TagSelectCountryByISO3 from "@/components/tag_select_country_by_iso3.vue";
// import TagSelectPublisher from "@/components/tag_select_publisher";
// // import TagSelectPublisher from "@/components/tag_select_publisher.vue";
// // import PublisherDynamicTags from "@/components/dynamic_tags_publishers.vue";
// import FactsTable from "@/facts/table.vue";
// // import DatasetList from "@/tabular_datasets/list.vue";

// export default {
//   components: {
//     QuickFacts,
//     TagSelectCountryByISO3,
//     TagSelectPublisher,
//     // PublisherDynamicTags,
//     FactsTable,
//     // DatasetList,
//   },

//   props: ["id", "isClone"],

//   created() {
//     if (this.id == null) {
//       this.getUUID();
//     } else {
//       this.load();
//     }
//   },

//   data() {
//     return {
//       activeTab: 0,
//       loading: false,
//       document: {
//         id: this.id,
//         name: "",
//         type: "",
//         publication_date: null,
//         comment: "",
//         url: "",
//         confidential: false,
//         displacement_types: [],
//         countries: [],
//         sources: [],
//         publishers: [],
//       },
//       rules: {
//         name: [
//           {
//             required: true,
//             message: "Name is required",
//           },
//           {
//             min: 3,
//             message: "Length should be more thab 3",
//           },
//         ],
//         publication_date: {
//           required: true,
//           message: "Publication date is required",
//         },
//         sources: {
//           required: true,
//           message: "Sources are required",
//         },
//         publishers: {
//           required: true,
//           message: "Sources are required",
//         },
//         url: [
//           {
//             type: "url",
//             message: "URL is not valid",
//           },
//         ],
//       },
//       dateFieldOptions: {
//         disabledDate(date) {
//           return date && date.valueOf() > Date.now();
//         },
//       },
//       typeOptions: ["Web", "PDF", "Email", "Excel", "Phone", "Fax"],
//       loadingOptions: false,
//       grabFileLoading: false,
//       factCount: 0,
//     };
//   },
//   computed: {
//     isNew() {
//       return this.document.id == null || this.isClone;
//     },
//     namePublishers() {
//       let publishers = "";
//       if (
//         this.document.publishers != null &&
//         this.document.publishers.length > 0
//       ) {
//         publishers =
//           this.document.publishers.map(p => p.name).join(", ") + ": ";
//       }
//       return publishers;
//     },
//     nameCountries() {
//       let countries = "";
//       if (
//         this.document.countries != null &&
//         this.document.countries.length > 0
//       ) {
//         countries = " (" + this.document.countries.join(", ") + ")";
//       }
//       return countries;
//     },
//     nameDate() {
//       let publicationDate = "";
//       let date = moment(this.document.publication_date);
//       if (this.document.publication_date != null && date.isValid()) {
//         publicationDate = " - " + date.format("DD/MM/YYYY");
//       }
//       return publicationDate;
//     },
//     fullname() {
//       return (
//         this.namePublishers +
//         this.document.name +
//         this.nameCountries +
//         this.nameDate
//       );
//     },
//   },
//   methods: {
//     setLoading(value) {
//       this.loading = value;
//     },
//     debug(e) {
//       e.preventDefault();
//       this.$refs["documentForm"].validate();
//       console.log(this.document);
//     },

//     // Load a document by ID
//     load() {
//       if (this.id != null) {
//         // Loader off
//         this.loading = true;
//         this.$Loading.start();
//         // Get document
//         database
//           .load("documents", this.id)
//           .then(response => {
//             // Cast publication_date
//             response.data.publication_date = new Date(
//               response.data.publication_date
//             );
//             // Remove all unique ids if clone
//             if (this.isClone) {
//               delete response.data.id;
//               delete response.data.uuid;
//               delete response.data.serial_no;
//               delete response.data.gsn;
//             }
//             // Update model
//             this.document = response.data;
//             // UUID
//             if (this.document.uuid == null) {
//               this.getUUID();
//             }
//             // Loader off
//             this.loadingSuccess();
//             this.loading = false;
//           })
//           .catch(err => {
//             console.error(err);
//             // Loader off
//             this.loadingError();
//             this.loading = false;
//           });
//       }
//     },

//     save() {
//       if (!this.$can("manage", "documents")) {
//         this.$Message.error("User is not permitted");
//         return;
//       }
//       const isNew = this.isNew;
//       this.$refs["documentForm"].validate(valid => {
//         if (valid) {
//           this.$Loading.start();
//           database
//             .save("documents", _.cloneDeep(this.document), {})
//             .then(response => {
//               console.log(response);
//               this.document = response.data;
//               this.loadingSuccess(
//                 isNew
//                   ? "Document has been created"
//                   : "Document has been updated"
//               );
//               this.$router.push(`/documents/${this.document.id}`);
//             })
//             .catch(err => {
//               console.error(err.response);
//               this.loadingError(
//                 isNew
//                   ? "Failed to create document"
//                   : "Failed to update document"
//               );
//             });
//         } else {
//           this.$Message.error("Check form errors");
//         }
//       });
//     },
//     // Drop a document from the database
//     drop() {
//       if (!this.$can("delete", "documents")) {
//         this.$Message.error("User is not permitted");
//         return;
//       }
//       this.$Modal.confirm({
//         title: "Delete Document",
//         content:
//           "This action will permanently delete this document, are you sure?",
//         onOk: () => {
//           this.$Loading.start();
//           database
//             .delete("documents", this.document.id)
//             .then(() => {
//               this.loadingSuccess("Successfully deleted");
//               this.$router.push(`/documents`);
//             })
//             .catch(err => {
//               console.error(err.response);
//               this.loadingError(
//                 "Failed to delete: " + err.response.data.message
//               );
//             });
//         },
//       });
//     },

//     grabFile() {
//       // if (!document.uuid) {
//       //   this.$Notice.error({
//       //     title: "UUID is missing",
//       //     desc: "Try to save an refresh the page before uploading",
//       //   });
//       // }
//       this.grabFileLoading = true;
//       axios
//         .post("/upload/url", {
//           uuid: this.document.uuid,
//           url: this.document.url,
//         })
//         .then(response => {
//           this.document.filename = response.data.filename;
//           this.document.content_type = response.data.content_type;
//           this.document.original_filename =
//             response.data.original_filename === ""
//               ? null
//               : response.data.original_filename;
//           console.log(response);
//           this.successNotice("Resource has been created successfully");
//           this.grabFileLoading = false;
//         })
//         .catch(error => {
//           this.grabFileLoading = false;
//           console.error(error.response);
//           this.errorNotice("Resource failed to create");
//         });
//     },

//     fileUploaded(response) {
//       this.document.original_filename = response.original_filename;
//       this.document.filename = response.filename;
//       this.document.content_type = response.content_type;
//       this.successNotice(
//         `${response.original_filename} has been uploaded successfully`
//       );
//     },

//     getUUID() {
//       console.log("getUUID");
//       database
//         .rpc("uuid_generate_v4")
//         .then(response => {
//           this.document.uuid = response.data;
//           console.log(this.document.uuid);
//         })
//         .catch(error => {
//           console.error(error);
//           this.$Notice.error("Failed to fetch a UUID");
//         });
//     },
//   },
// };
